import sendApplicantContext from '../sendApplicantContext'
import storage from 'proxy-storage'
import store from 'utils/store/withMiddleware'
import { sendOnCloseEvent } from '../email/blueshift/implementations/on-close'

export async function updateSessionContext(hcStorage, pageConfig) {
  if (hcStorage.healthcareSession !== hcStorage.lastHealthcareSession) {
    await sendApplicantContext(hcStorage, pageConfig)
    if (
      typeof hcStorage.lastHealthcareSession !== 'undefined' &&
      hcStorage.lastHealthcareSession
    )
      sendOnCloseEvent(hcStorage.lastHealthcareSession) // onRefresh
    hcStorage.lastHealthcareSession = hcStorage.healthcareSession
    storage.setItem('hc', hcStorage)
    store.update({ hcStorage }, true)
  }
}

export async function updateSendSessionContext(hcStorage, pageConfig) {
  if (hcStorage.healthcareSession !== hcStorage.lastHealthcareSession) {
    if (
      typeof hcStorage.lastHealthcareSession !== 'undefined' &&
      hcStorage.lastHealthcareSession
    )
      sendOnCloseEvent(hcStorage.lastHealthcareSession) // onRefresh
    hcStorage.lastHealthcareSession = hcStorage.healthcareSession
    storage.setItem('hc', hcStorage)
    store.update({ hcStorage }, true)
  }

  await sendApplicantContext(hcStorage, pageConfig)
}
